  // Auth is session-only: the user (and its access/refresh tokens) lives in
  // sessionStorage, which the browser clears when it closes — so closing the browser
  // logs the user out. We never persist it to localStorage.
const getStoredUser = () => {
    const fromSession = sessionStorage.getItem("user");
    return fromSession ? JSON.parse(fromSession) : null;
  };

  const getLocalRefreshToken = () => {
    const user = getStoredUser();
    return user?.refreshToken;
  };

  const getLocalAccessToken = () => {
    const user = getStoredUser();
    return user?.accessToken;
  };

  const updateLocalAccessToken = (token) => {
    const user = getStoredUser();
    if (!user) return;
    user.accessToken = token.accessToken;
    user.refreshToken = token.refreshToken;
    sessionStorage.setItem("user", JSON.stringify(user));
  };

  const getUser = () => {
    return getStoredUser();
  };

  const setUser = (user) => {
    user.logged = true;
    sessionStorage.setItem("user", JSON.stringify(user));
  };

  const removeUser = () => {
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
  };
  
  const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
  };
  
  export default TokenService;
  